import * as React from "react";
const SvgFiBrandsVisa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M9.493 8.261 6.22 15.758H4.084L2.475 9.775c-.099-.369-.183-.503-.481-.66C1.507 8.863.706 8.626 0 8.478l.049-.218h3.436c.439 0 .833.281.932.764l.85 4.339L7.37 8.26zm8.365 5.048c.01-1.977-2.85-2.085-2.829-2.97.005-.27.272-.556.856-.628.29-.037 1.088-.064 1.993.334l.354-1.589a5.6 5.6 0 0 0-1.89-.332c-1.996 0-3.401 1.019-3.413 2.478-.013 1.079 1.003 1.681 1.769 2.04.786.368 1.05.602 1.047.932-.005.503-.628.723-1.208.733-1.016.015-1.606-.264-2.077-.474l-.365 1.644c.47.208 1.343.388 2.247.399 2.121 0 3.51-1.009 3.516-2.567m5.273 2.448H25L23.37 8.26h-1.725a.92.92 0 0 0-.86.55l-3.03 6.947h2.121l.42-1.12h2.593zm-2.254-2.656 1.064-2.815.611 2.815zm-8.498-4.84-1.672 7.497h-2.02l1.672-7.497z"
    />
  </svg>
);
export default SvgFiBrandsVisa;
